import React from "react";

export default function StepWrapper(props: { children: React.ReactNode }) {
  return (
    <div className="flex flex-col justify-between items-center h-full w-full">
      {props.children}
    </div>
  );
}
 